import Cookies from "js-cookie";

export const getCookie = name => Cookies.get(name);